import { c as _c } from "react/compiler-runtime";
import { Heading, TextPassage } from '@petsmart-ui/sparky';
import { AUTOSHIP_RECURRING_ORDERS_DISCOUNT } from '@libs/core';
import './AutoshipInfoDrawer.scss';
type AutoshipDiscountContentProps = {
  discount: string;
  maxSavings: string;
};
export const AutoshipMapRestrictedContent = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Heading tagName="h4" size="headline">Subscribe with Autoship</Heading><TextPassage className="autoship-info-drawer__dynamic-discount">Future orders ship to you on your schedule</TextPassage></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const AutoshipFirstTimeEligibleContent = t0 => {
  const $ = _c(9);
  const {
    discount,
    maxSavings
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Heading tagName="h4" size="headline">{"How to Autoship & save"}</Heading>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Save ${discount}`;
  let t3;
  if ($[1] !== t2) {
    t3 = <strong>{t2}</strong>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== maxSavings || $[4] !== t3) {
    t4 = <TextPassage>{t3} on your first Autoship order (up to {maxSavings})</TextPassage>;
    $[3] = maxSavings;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TextPassage className="autoship-info-drawer__dynamic-discount"><strong>{`${AUTOSHIP_RECURRING_ORDERS_DISCOUNT} off`}</strong> on future orders</TextPassage>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <>{t1}{t4}{t5}</>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export const AutoshipExistingSubscriberContent = t0 => {
  const $ = _c(9);
  const {
    discount,
    maxSavings
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Heading tagName="h4" size="headline">{"How to Autoship & save"}</Heading>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Save ${discount}`;
  let t3;
  if ($[1] !== t2) {
    t3 = <strong>{t2}</strong>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== maxSavings || $[4] !== t3) {
    t4 = <TextPassage>{t3} on your Autoship order (up to {maxSavings})</TextPassage>;
    $[3] = maxSavings;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TextPassage className="autoship-info-drawer__dynamic-discount"><strong>{`${AUTOSHIP_RECURRING_ORDERS_DISCOUNT} off`}</strong> on future orders</TextPassage>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <>{t1}{t4}{t5}</>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};